var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"matrixBox",staticClass:"image-zoom",style:(_vm.zoomStyle),on:{"touchstart":_vm.start,"touchmove":_vm.move,"touchend":_vm.end}},[_c('sd-img',{attrs:{"src":_vm.src,"safe":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e0766a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/zoom.vue
// module id = null
// module chunks = 